define('OnlyGiftCertificates.LiveOrder.Model', [
    'LiveOrder.Model',
    'underscore'
], function OnlyGiftCertificatesLiveOrderModel(
    LiveOrderModel,
    _
) {
    'use strict';

    _.extend(LiveOrderModel.prototype, {
        getNonShippableLines: function getNonShippableLines() {
            var self = this;
            return this.get('lines').filter(function(line) {
                return !line.get('item').get('_isfulfillable') || self.get('onlyGifts');
            });
        },
    });
});
